import {CellTitleDefaultBox} from './cell-title.default.box';
import {styledByTheme} from '../../../../../../../../themes/architecture/styled-by-theme';
import {CellTitleMrGreenBox} from './cell-title.mrgeen.box'

export const CellTitleBox = styledByTheme(CellTitleDefaultBox)
.forMrGreen(CellTitleMrGreenBox)
.apply();